import Button from "@/components/button";
import Icon from "@/components/icon";
import { EDUCATORS_EITAA_LINK } from "@/utils/constant";
import { openUrl } from "@/utils/utilities";

type Props = {
  className?: string;
  iconSize?: number;
};

export default function EducatorsPublishButton({
  className,
  iconSize = 24,
}: Props) {
  return (
    <Button asChild size="lg" className={className}>
      <a
        href={EDUCATORS_EITAA_LINK}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(event) => {
          event.preventDefault();
          openUrl(EDUCATORS_EITAA_LINK);
        }}
      >
        <span>انتشار دوره در آموزیم</span>
        <Icon name="arrow-left" size={iconSize} />
      </a>
    </Button>
  );
}
